module.exports = __webpack_public_path__ + "img/kh.5b110315.svg";